function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ua from '@tencent/docs-user-agent';
import { evokeAddMember as _evokeAddMember, evokeContactSelector as _evokeContactSelector, evokeFriendSelector as _evokeFriendSelector, evokeTransferOwner as _evokeTransferOwner, exitCurrentDocument as _exitCurrentDocument, loadMemberButton as _loadMemberButton, openCreateSpaceSetting as _openCreateSpaceSetting, openDocSizePanel as _openDocSizePanel, openFormFillPanel as _openFormFillPanel, openMemberPanel as _openMemberPanel, openPermissionSetting as _openPermissionSetting, openSpaceSetting as _openSpaceSetting, enableSafeFolder as _enableSafeFolder, retrieveSafeFolderPassword as _retrieveSafeFolderPassword, changeSafeFolderPassword as _changeSafeFolderPassword, unlockSafeFolder as _unlockSafeFolder, openSharePanel as _openSharePanel, openCooperation as _openCooperation } from '@tencent/tdocs-docs-component-service';
import { createExtensionServiceIfNeed } from "./utils";
var DocsComponentFacadeImp = /*#__PURE__*/function () {
  function DocsComponentFacadeImp() {
    _classCallCheck(this, DocsComponentFacadeImp);
  }
  _createClass(DocsComponentFacadeImp, [{
    key: "openPermissionSetting",
    value: (
    /**
     * 打开权限面板
     * @param options
     */
    function () {
      var _openPermissionSetting2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _openPermissionSetting(options);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function openPermissionSetting(_x) {
        return _openPermissionSetting2.apply(this, arguments);
      }
      return openPermissionSetting;
    }()
    /**
     * 加载成员按钮
     */
    )
  }, {
    key: "loadMemberButton",
    value: (function () {
      var _loadMemberButton2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(options) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _loadMemberButton(options);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function loadMemberButton(_x2) {
        return _loadMemberButton2.apply(this, arguments);
      }
      return loadMemberButton;
    }()
    /**
     * 打开成员面板
     */
    )
  }, {
    key: "openMemberPanel",
    value: (function () {
      var _openMemberPanel2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(options) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _openMemberPanel(options);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function openMemberPanel(_x3) {
        return _openMemberPanel2.apply(this, arguments);
      }
      return openMemberPanel;
    }()
    /**
     * 打开创建共享空间面板
     * @param options
     */
    )
  }, {
    key: "openCreateSpaceSetting",
    value: (function () {
      var _openCreateSpaceSetting2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(options) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _openCreateSpaceSetting(options);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function openCreateSpaceSetting(_x4) {
        return _openCreateSpaceSetting2.apply(this, arguments);
      }
      return openCreateSpaceSetting;
    }()
    /**
     * 打开共享空间设置面板
     * @param options
     */
    )
  }, {
    key: "openSpaceSetting",
    value: (function () {
      var _openSpaceSetting2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(options) {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _openSpaceSetting(options);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function openSpaceSetting(_x5) {
        return _openSpaceSetting2.apply(this, arguments);
      }
      return openSpaceSetting;
    }()
    /**
     * 唤起通讯录
     * @param config
     */
    )
  }, {
    key: "evokeContactSelector",
    value: (function () {
      var _evokeContactSelector2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(config) {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              return _context6.abrupt("return", _evokeContactSelector(config));
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function evokeContactSelector(_x6) {
        return _evokeContactSelector2.apply(this, arguments);
      }
      return evokeContactSelector;
    }())
  }, {
    key: "evokeFriendSelector",
    value: function () {
      var _evokeFriendSelector2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(options) {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              return _context7.abrupt("return", _evokeFriendSelector(options));
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function evokeFriendSelector(_x7) {
        return _evokeFriendSelector2.apply(this, arguments);
      }
      return evokeFriendSelector;
    }()
  }, {
    key: "evokeTransferOwner",
    value: function () {
      var _evokeTransferOwner2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(options) {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _evokeTransferOwner(options);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function evokeTransferOwner(_x8) {
        return _evokeTransferOwner2.apply(this, arguments);
      }
      return evokeTransferOwner;
    }()
  }, {
    key: "evokeAddMember",
    value: function () {
      var _evokeAddMember2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(options) {
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _evokeAddMember(options);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function evokeAddMember(_x9) {
        return _evokeAddMember2.apply(this, arguments);
      }
      return evokeAddMember;
    }()
    /**
     * 退出当前文档
     */
  }, {
    key: "exitCurrentDocument",
    value: (function () {
      var _exitCurrentDocument2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(options) {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _exitCurrentDocument(options);
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      function exitCurrentDocument(_x10) {
        return _exitCurrentDocument2.apply(this, arguments);
      }
      return exitCurrentDocument;
    }()
    /**
     * 打开文档大小面板
     */
    )
  }, {
    key: "openDocSizePanel",
    value: (function () {
      var _openDocSizePanel2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(options) {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _openDocSizePanel(options);
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
      function openDocSizePanel(_x11) {
        return _openDocSizePanel2.apply(this, arguments);
      }
      return openDocSizePanel;
    }()
    /**
     * 打开表单填写链接管理面板
     */
    )
  }, {
    key: "openFormFillPanel",
    value: (function () {
      var _openFormFillPanel2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(options) {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _openFormFillPanel(options);
            case 3:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
      function openFormFillPanel(_x12) {
        return _openFormFillPanel2.apply(this, arguments);
      }
      return openFormFillPanel;
    }()
    /**
     * 启用加密文件夹
     */
    )
  }, {
    key: "enableSafeFolder",
    value: (function () {
      var _enableSafeFolder2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(options) {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _enableSafeFolder(options);
            case 3:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }));
      function enableSafeFolder(_x13) {
        return _enableSafeFolder2.apply(this, arguments);
      }
      return enableSafeFolder;
    }()
    /**
     * 加密文件夹修改密码
     */
    )
  }, {
    key: "changeSafeFolderPassword",
    value: (function () {
      var _changeSafeFolderPassword2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(options) {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _changeSafeFolderPassword(options);
            case 3:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      }));
      function changeSafeFolderPassword(_x14) {
        return _changeSafeFolderPassword2.apply(this, arguments);
      }
      return changeSafeFolderPassword;
    }()
    /**
     * 加密文件夹找回密码
     */
    )
  }, {
    key: "retrieveSafeFolderPassword",
    value: (function () {
      var _retrieveSafeFolderPassword2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(options) {
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _retrieveSafeFolderPassword(options);
            case 3:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      }));
      function retrieveSafeFolderPassword(_x15) {
        return _retrieveSafeFolderPassword2.apply(this, arguments);
      }
      return retrieveSafeFolderPassword;
    }()
    /**
     * 解锁加密文件夹
     */
    )
  }, {
    key: "unlockSafeFolder",
    value: (function () {
      var _unlockSafeFolder2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(options) {
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _unlockSafeFolder(options);
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }));
      function unlockSafeFolder(_x16) {
        return _unlockSafeFolder2.apply(this, arguments);
      }
      return unlockSafeFolder;
    }()
    /**
     * 打开分享面板
     * @param options
     */
    )
  }, {
    key: "openSharePanel",
    value: (function () {
      var _openSharePanel2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(options) {
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              if (!ua.isPC) {
                options.isMobile = true;
              }
              _openSharePanel(options);
            case 4:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }));
      function openSharePanel(_x17) {
        return _openSharePanel2.apply(this, arguments);
      }
      return openSharePanel;
    }()
    /**
     * 打开协作管理组件
     */
    )
  }, {
    key: "openCooperation",
    value: (function () {
      var _openCooperation2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(options) {
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return createExtensionServiceIfNeed();
            case 2:
              _openCooperation(options);
            case 3:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }));
      function openCooperation(_x18) {
        return _openCooperation2.apply(this, arguments);
      }
      return openCooperation;
    }())
  }]);
  return DocsComponentFacadeImp;
}();
export var DocsComponentFacade = new DocsComponentFacadeImp();